import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { trimStart, isBoolean } from 'lodash';

import { TextLabel } from 'v-c/Widgets/Components';
import { PlusBlueIcon, MinusRedIcon, CheckmarkGreenIcon, PlusGrayCircleIcon } from 'v-c/Icons';
import LargeCheckbox from 'v-c/Forms/Checkboxes/LargeCheckbox';
import { FormLabel, FormText, InputField, FormErrorText } from 'v-c/Forms';

import defaults from '../defaults.json';

import styles from './tabs.scss';

const BASE_KEY = 'components.templates.edit_user';

export default class EmailsTab extends Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        validators: PropTypes.object.isRequired,
        isHandlesStatusEnabled: PropTypes.bool.isRequired,
        reactForm: PropTypes.shape({
            fields: PropTypes.object.isRequired,
        }).isRequired,
        getMessage: PropTypes.func.isRequired,
        status: PropTypes.string.isRequired,
    };

    onHandleChange = (idx, prop) => ({ target: { value } }) => {
        const { fields } = this.props.reactForm;

        const modifiedHandles = [...fields.handles.value];
        modifiedHandles[idx] = {
            ...modifiedHandles[idx],
            [prop]: trimStart(value),
        };
        fields.handles.change(modifiedHandles);
    };

    get savedHandles() {
        const {
            getMessage,
            reactForm: { fields },
            isHandlesStatusEnabled,
        } = this.props;

        const savedHandles = fields.handles.value.filter(handle => (handle['handle-id'] || handle.handleId) && handle.handle !== fields.email.value,);

        if (savedHandles.length) {
            return (
                <div className={styles['form-row']}>
                    {savedHandles.map((handle) => {
                        const handleId = handle['handle-id'] || handle.handleId;

                        return (
                            <div className="saved-handle" key={handleId}>
                                <MinusRedIcon
                                    className="saved-handle-minus-icon"
                                    onClick={this.deleteHandle(handleId)}
                                />
                                <TextLabel className="saved-handle-value">
                                    {handle.handle}
                                </TextLabel>
                                {isHandlesStatusEnabled && (
                                    <data>
                                        <CheckmarkGreenIcon className="confirmed-icon" />
                                        <div className={styles['confirmed-handle']}>
                                            {getMessage(`${BASE_KEY}.confirmed`).toLowerCase()}
                                        </div>
                                    </data>
                                )}
                            </div>
                        );
                    })}
                    <div style={{ clear: 'left' }} />
                </div>
            );
        }

        return null;
    }

    get shouldShowEmail() {
        return (
            !this.props.validators.email &&
      this.props.validators.email !== 'components.validation_issues.empty_error'
        );
    }

    /* eslint-disable react/no-array-index-key */
    get handles() {
        const {
            getMessage,
            reactForm: { fields },
            validators,
            status,
        } = this.props;

        return fields.handles.value.map((handle, idx) => {
            const handleId = handle['handle-id'] || handle.handleId;
            const handleError = validators.handles[idx];

            if (!handleId) {
                return (
                    <div key={idx} data-handle={idx} style={{ clear: 'left' }}>
                        <div className={styles['tab-content-column']}>
                            <div className={styles['form-row']}>
                                <FormLabel required>
                                    {getMessage(`${BASE_KEY}.additional_email`)}
                                </FormLabel>
                                <div className={styles['medium-input']}>
                                    <InputField
                                        type="text"
                                        data-field={`handle-${idx}`}
                                        value={handle.handle}
                                        onChange={this.onHandleChange(idx, 'handle')}
                                        status={status}
                                    />
                                </div>
                                <FormErrorText
                                    field="email-form-error"
                                    error={handleError}
                                    values={{
                                        field: 'ADDITIONAL EMAIL',
                                        matchField: 'CONFIRM ADDITIONAL EMAIL',
                                    }}
                                />
                            </div>
                        </div>
                        <div className={styles['tab-content-column']}>
                            <div className={styles['form-row']}>
                                <FormLabel required>
                                    {getMessage(`${BASE_KEY}.confirm_additional_email`)}
                                </FormLabel>
                                <div className={styles['medium-input']}>
                                    <InputField
                                        type="text"
                                        data-field={`confirm-handle-${idx}`}
                                        value={handle.confirmHandle}
                                        onChange={this.onHandleChange(idx, 'confirmHandle')}
                                        status={status}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }

            return null;
        });
    }
    /* eslint-enable react/no-array-index-key */

    toggleWelcomeEmailStatus = () => {
        const {
            reactForm: { fields },
            validators,
        } = this.props;

        if (!validators.email) {
            fields.sendWelcomeEmail.change(!fields.sendWelcomeEmail.value);
        }
    };

    addNewHandle = () => {
        const {
            reactForm: { fields },
            status,
        } = this.props;

        if (!status) {
            fields.handles.change([...fields.handles.value, { ...defaults.HANDLE }]);
        }

        return null;
    };

    deleteHandle = handleId => () => {
        const { fields } = this.props.reactForm;
        const modifiedHandles = fields.handles.value.filter(handle => (handle['handle-id'] || handle.handleId) !== handleId,);

        fields.handles.change(modifiedHandles);
    };

    render() {
        const {
            getMessage,
            reactForm: { fields },
            validators,
            status,
        } = this.props;

        if (!isBoolean(fields.sendWelcomeEmail.value)) {
            return null;
        }

        return (
            <div className={`emails-section ${styles['accordion-content']}`}>
                <div className={styles['tab-content-column']}>
                    <div className={styles['form-row']}>
                        <FormLabel required>
                            {getMessage(`${BASE_KEY}.email`)}
                        </FormLabel>
                        <div className={styles['medium-input']}>
                            <InputField
                                type="text"
                                data-field="email"
                                {...fields.email}
                                status={status}
                            />
                        </div>
                        <FormErrorText
                            field="email-form-error"
                            error={validators.email}
                            values={{
                                field: 'EMAIL',
                                matchField: 'CONFIRM EMAIL',
                            }}
                        />
                    </div>
                </div>
                <div className={styles['tab-content-column']}>
                    <div className={styles['form-row']}>
                        <FormLabel required>
                            {getMessage(`${BASE_KEY}.confirm_email`)}
                        </FormLabel>
                        <div className={styles['medium-input']}>
                            <InputField
                                type="text"
                                data-field="confirm-email"
                                {...fields.confirmEmail}
                                status={status}
                            />
                        </div>
                    </div>
                </div>
                <div style={{ clear: 'left' }} />
                {this.savedHandles}
                <div style={{ clear: 'left' }} />
                {this.handles}
                <div style={{ clear: 'left' }} />
                <div className={styles['form-row']}>
                    <div
                        className={status ? styles['form-text-inactive'] : styles['form-blue-text']}
                        data-action="add_more"
                        onClick={this.addNewHandle}
                        role="button"
                        tabIndex="-1"
                    >
                        {status
                            ? (<PlusGrayCircleIcon />)
                            : (<PlusBlueIcon />)}
                        {getMessage(`${BASE_KEY}.add_email`)}
                    </div>
                </div>
                <div style={{ clear: 'left' }} />
                <div
                    className={styles['form-row']}
                    data-action="send-welcome-email"
                    onClick={this.toggleWelcomeEmailStatus}
                    role="checkbox"
                    tabIndex="-1"
                    aria-checked={fields.sendWelcomeEmail.value}
                >
                    <FormText>
                        <LargeCheckbox
                            data-action="send-welcome-email-checkbox"
                            disabled={!!validators.email || !!status}
                            checked={fields.sendWelcomeEmail.value}
                        />
                        {getMessage(`${BASE_KEY}.send_welcome_email`)}
                        {this.shouldShowEmail && (
                            <data className="primary-email-address">
                                {` (${fields.email.value})`}
                            </data>
                        )}
                    </FormText>
                </div>
                <div style={{ clear: 'left' }} />
            </div>
        );
    }
}
